"use strict";

var _toConsumableArray = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnumCheckboxSelect = exports.EnumRadioSelect = exports.EnumSelect = void 0;

var antd_1 = require("antd");

var case_1 = __importDefault(require("case"));

var react_1 = __importStar(require("react"));

var index_1 = require("./index");

var key = function key(e, _key) {
  return e[_key];
};

function EnumSelect(_a) {
  var _enum = _a["enum"],
      _a$labels = _a.labels,
      labels = _a$labels === void 0 ? {} : _a$labels,
      props = __rest(_a, ["enum", "labels"]);

  return react_1["default"].createElement(antd_1.Select, Object.assign({}, props), Object.keys(_enum).map(function (enumKey) {
    return react_1["default"].createElement(antd_1.Select.Option, {
      key: enumKey,
      value: key(_enum, enumKey)
    }, labels[key(_enum, enumKey)] || case_1["default"].title(enumKey));
  }));
}

exports.EnumSelect = EnumSelect;

function EnumRadioSelect(_a) {
  var _enum = _a["enum"],
      isVertical = _a.isVertical,
      _a$labels2 = _a.labels,
      labels = _a$labels2 === void 0 ? {} : _a$labels2,
      props = __rest(_a, ["enum", "isVertical", "labels"]);

  var theme = (0, react_1.useContext)(index_1.StyledThemeContext);
  var style = isVertical ? {
    display: 'block',
    height: theme['@size-l'],
    lineHeight: theme['@size-l'],
    marginLeft: 0
  } : {};
  var content = react_1["default"].createElement(antd_1.Radio.Group, Object.assign({}, props), Object.keys(_enum).map(function (enumKey) {
    return react_1["default"].createElement(antd_1.Radio, {
      key: enumKey,
      value: key(_enum, enumKey),
      style: style
    }, labels[key(_enum, enumKey)] || case_1["default"].title(enumKey));
  }));
  return react_1["default"].createElement(react_1["default"].Fragment, null, content);
}

exports.EnumRadioSelect = EnumRadioSelect;

function EnumCheckboxSelect(_ref) {
  var _enum = _ref["enum"],
      value = _ref.value,
      _onChange = _ref.onChange,
      isVertical = _ref.isVertical,
      _ref$labels = _ref.labels,
      labels = _ref$labels === void 0 ? {} : _ref$labels;
  var theme = (0, react_1.useContext)(index_1.StyledThemeContext);
  var style = isVertical ? {
    display: 'block',
    height: theme['@size-l'],
    lineHeight: theme['@size-l'],
    marginLeft: 0
  } : {};
  var content = Object.keys(_enum).map(function (enumKey) {
    return react_1["default"].createElement(antd_1.Checkbox, {
      key: enumKey,
      checked: value === null || value === void 0 ? void 0 : value.includes(key(_enum, enumKey)),
      style: style,
      onChange: function onChange(e) {
        if (_onChange) {
          var without = (value || []).filter(function (i) {
            return i !== key(_enum, enumKey);
          });

          if (e.target.checked) {
            _onChange([].concat(_toConsumableArray(without), [key(_enum, enumKey)]));
          } else {
            _onChange(without);
          }
        }
      }
    }, labels[key(_enum, enumKey)] || case_1["default"].title(enumKey));
  });
  return react_1["default"].createElement(react_1["default"].Fragment, null, content);
}

exports.EnumCheckboxSelect = EnumCheckboxSelect;